module.exports = __webpack_public_path__ + "static/1216094652.bbf9c527.jpg";